import styled from 'styled-components';

export const ScanQrCodeWrapper = styled.div`
    margin-top: 48px;
    display: flex;
    width: 132px;
    height: 132px;
    padding: 10px;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    background-color: #fff;
`;

export const QRWrapper = styled.div`
    width: 112px;
    height: 112px;
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 8px;
`;
